import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { translate } from 'react-switch-lang';
import chatStorage from './chatStorage';

class ConversationItem extends React.PureComponent {
  render() {
    const {
      t,
      status,
      conversationStatus,
      account: {
        name, first_name, last_name, avatar,
      },
      lastSeen,
      lastMessage,
      unreadedMessages,
      id,
      unviewed,
      contacts,
      updated_at,
    } = this.props;
    const changeChat = () => chatStorage.changeCurrentChat(id);
    const containerClass = classNames({
      'user-list__item': true,
      'flex-row': true,
      'active-conversation': id == chatStorage.currentChatID,
      'unsubscribed-conversation': conversationStatus < 0,
      'notsubscribed-conversation': conversationStatus == 0,
    });
    const badgeClass = classNames({
      'badge-online': status === 1,
      'badge-online-1': status === 2,
      'flex-config': true,
    });
    const lastUpdate = updated_at.toLocaleDateString();
    let displayName = name || 'Unknown';
    let useRealName = false;
    if (first_name || last_name) {
      displayName = (`${first_name} ${last_name}`).trim();
      useRealName = true;
    }
    return (
      <li className={containerClass} onClick={changeChat}>
        <div className="image-container">
          <img src={avatar || '/images/user.png'} alt="" className="img-50 rounded-circle" loading="lazy" />
        </div>
        <div className={badgeClass} />
        <div className="text-container_info">
          <div className="text-container_info_top-text flex-row justify-content-between">
            <div className="contact-info" style={{ color: useRealName ? 'darkgreen' : 'inherit' }}>
              {displayName || name}
              <br />
              {contacts && contacts.value && (
                <span className="contactPhone">
                  <i className="fa fa-phone" />
                  {' '}
                  {contacts.value}
                </span>
              )}
              <span className="updatedDate">{lastUpdate}</span>
            </div>
            <div className="flex-row">
              <div>{lastSeen}</div>
            </div>
          </div>
          <div className="flex-row justify-content-between">
            {/* <div className="text-truncate"> */}
            <p className="text-truncate">
              {conversationStatus == 0 && t('Not subscribed')}
              {conversationStatus < 0 && t('Unsubscribed')}
              {lastMessage}
            </p>
            {/* </div> */}
            {unviewed > 0 && (
              <div className="badge-messages flex-row">
                <span className="badge-messages_text">{unviewed}</span>
              </div>
            )}
          </div>

        </div>
      </li>
    );
  }
}

ConversationItem.defaultProps = {
  unreadedMessages: 0,
  lastMessage: '',
  lastSeen: null,
  name: null,
  status: 0,
  avatar: null,
};
ConversationItem.propTypes = {
  status: PropTypes.number,
  name: PropTypes.string,
  lastSeen: PropTypes.string,
  lastMessage: PropTypes.string,
  unreadedMessages: PropTypes.number,
  avatar: PropTypes.string,
  id: PropTypes.number.isRequired,
};

export default translate(observer(ConversationItem));
